import React, { useEffect } from 'react'; 
import { useParams } from 'react-router-dom';  // Asegúrate de importar useParams aquí
import { useSucursal } from '../../contexts/SucursalContext';
import NavbarUni from './componentes/headUni';
import FooterPublic from './FooterPublic';
//import ModalAuto from './componentes/ModalAuto';
import CategoriasUni from './ventaUnidad/componenetes/categoriasUni';
import Marquee from './componentes/marquee';
//import BarCar from './componentes/barCar';
import ModalAuto from './componentes/ModalAuto';

function CatalogoAll() {
    const { idSucursal: urlIdSucursal } = useParams(); // Extrae idSucursal de los parámetros de la URL
    const { idSucursal, setIdSucursal } = useSucursal(); // Accede al contexto de Sucursal

    useEffect(() => {
        if (urlIdSucursal && urlIdSucursal !== idSucursal) {
            setIdSucursal(urlIdSucursal); // Si el idSucursal es diferente, lo actualizamos
            localStorage.setItem('idSucursal', urlIdSucursal); // Guardamos el idSucursal en localStorage
        } else if (!idSucursal) {
            const storedIdSucursal = localStorage.getItem('idSucursal');
            if (storedIdSucursal) {
                setIdSucursal(storedIdSucursal);
            }
        }
    }, [urlIdSucursal, idSucursal, setIdSucursal]);

    return (
        <div className='bg-light'>
            <ModalAuto />
            <Marquee />
            <NavbarUni />
            <CategoriasUni idSucursal={idSucursal} />
            <FooterPublic idSucursal={idSucursal} />
        </div>
    );
}

export default CatalogoAll;
